import { CommonModule } from '@angular/common';
import { Component,  ChangeDetectionStrategy, Input, OnInit } from '@angular/core';
import {  TranslateModule, TranslateService } from '@ngx-translate/core';
import { AppInitService } from 'libs/api/src/lib/app-init/appinit.service';

@Component({
  selector: 'app-error-msg',
  templateUrl: './error-msg.component.html',
  styleUrls: ['./error-msg.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class ErrorMsgComponent{
  @Input() errors: any;
  @Input() fieldLabel: any;
  @Input() secondFieldLabel: any;
  @Input() localized=true;
  errormsg = '';
  constructor(public translate: TranslateService, public appInit: AppInitService) {
  }

  ngOnInit():void {
   
  }


  parsedata(e: any) {
  }
}
